export const scopes = '';
export const accessToken = '';
export const WEB_SOCKET_URL = process.env.WEB_SOCKET_URL;
export const TINYMCE_API_KEY = process.env.TINYMCE_API_KEY;
export const HEMS_USER_FEATURE_GROUP = process.env.HEMS_USER_FEATURE_GROUP;
